import { HTTP } from '../modules/http';
import { appConfig } from '../config/app.config';

export default new HTTP({
	baseURL: appConfig.APIBaseURL
});
